<div *ngFor="let alert of alerts; trackBy:trackByFn;" class="{{ cssClass(alert) }} alert-dismissable">
     {{ alert.message }}
     <a class="close" (click)="removeAlert(alert)">
        <i class="material-icons">cancel</i>
     </a>
</div>
